import React from 'react';
import {sortBy} from 'bigdatr-style';
import NzComingSoon from './articles/NzComingSoon';
import DataExportLaunch from './articles/DataExportLaunch';
import AdCompliance from './articles/AdCompliance';
import NzArrived from './articles/NzArrived';
import UiImprovements from './articles/UiImprovements';
import CreativeIndexLaunch from './articles/CreativeIndexLaunch';
import {useCountry} from '~/feature/country/CountryContext';
import {SupportedCountry} from 'bigdatr-style';
import NzCreativeInsightLaunch from './articles/NzCreativeInsightLaunch';
import AuCreativeInsightLaunch from './articles/AuCreativeInsightLaunch';
import CampaignGrouping from './articles/CampaignGrouping';
import ConnectedTV from './articles/ConnectedTV';

export default function useNewsItems() {
    const {country} = useCountry();
    const newsItems = sortBy(
        [
            // this news item is only meant for AU users
            ...(country === SupportedCountry.AU
                ? [
                      {
                          date: new Date('2026-07-01'),
                          title: 'Connected TV monitoring is here',
                          content: <ConnectedTV />
                      }
                  ]
                : []),
            {
                date: new Date('2025-12-03'),
                title: 'Introducing Campaign Grouping in your creative library',
                content: <CampaignGrouping />
            },
            // this news item is only meant for AU users
            ...(country === SupportedCountry.AU
                ? [
                      {
                          date: new Date('2025-10-09'),
                          title: 'AI-powered creative and demographic analysis with Creative Insights',
                          content: <AuCreativeInsightLaunch />
                      }
                  ]
                : []),
            // this news item is only meant for NZ users
            ...(country === SupportedCountry.NZ
                ? [
                      {
                          date: new Date('2025-07-31'),
                          title: 'Say hello to Creative Insights',
                          content: <NzCreativeInsightLaunch />
                      }
                  ]
                : []),
            {
                date: new Date('2025-05-27'),
                title: 'We’ve just launched a new feature: Creative Index',
                content: <CreativeIndexLaunch />
            },
            {
                date: new Date('2025-03-27'),
                title: 'UI Improvements',
                content: <UiImprovements />
            },
            {
                date: new Date('2024-10-14'),
                title: 'NZ Digital Creative - Now Available',
                content: <NzArrived />
            },
            {
                date: new Date('2024-08-15'),
                title: 'Mitigate Potential Risks with Advertising Compliance',
                content: <AdCompliance />
            },
            {
                date: new Date('2024-08-07'),
                title: 'New Update — Track Investment Behaviour and Media Growth',
                content: <DataExportLaunch />
            },
            {
                date: new Date('2024-06-25'),
                title: 'NZ Digital Creative - Coming Soon',
                content: <NzComingSoon />
            }
        ],
        (i) => i.date.getTime(),
        true
    );

    return newsItems;
}
